import { ga4Adapter } from "./gtag";

const adapters = [];

function useDefaultAdapters() {
  adapters.length = 0;
  adapters.push(ga4Adapter);
}

useDefaultAdapters();

export function registerAdapter(adapter) {
  if (!adapter || adapters.indexOf(adapter) !== -1) {
    return;
  }
  adapters.push(adapter);
}

function eachAdapter(invoke) {
  adapters.slice().forEach((adapter) => {
    try {
      invoke(adapter);
    } catch {
      // one provider must not block the others
    }
  });
}

export function initAdapters() {
  eachAdapter((adapter) => {
    if (typeof adapter.init === "function") {
      adapter.init();
    }
  });
}

export function dispatchTrack(eventName, properties, context) {
  eachAdapter((adapter) => {
    if (typeof adapter.track === "function") {
      adapter.track(eventName, properties, context);
    }
  });
}

export function dispatchPage(info) {
  eachAdapter((adapter) => {
    if (typeof adapter.page === "function") {
      adapter.page(info);
    }
  });
}

export function _resetAdaptersForTests() {
  useDefaultAdapters();
}
